<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">图片人脸检测与分析</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			对图片的BGR24倒立数据进行人脸检测与分析，该接口与视频人脸检测与跟踪接口存在互斥，不可并行调用
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">public void SKFaceImageDetect(byte[] BGR24Data, int Width, int Height, int Model, boolean AttributesModel, boolean FeatureModel, 
boolean KeyPointModel, final FaceDetectCallbackInterface FaceDetectCallback)
public FaceStruct[] SKFaceImageDetect(byte[] BGR24Data, int Width, int Height, int Model, boolean AttributesModel, 
boolean FeatureModel, boolean KeyPointModel) 
// 人脸检测结果回调接口
public interface FaceDetectCallbackInterface {
void FaceDetectCallback (FaceStruct[] FaceStructs);
}</code></pre>
        <h3 class="doc_main_h3">参数</h3>
        <p class="doc_main_p">（1）BGR24Data：图片的BGR数据（BGR倒立数据）</p>
        <p class="doc_main_p">（2）Width：图片宽度</p>
        <p class="doc_main_p">（3）Height：图片高度</p>
        <p class="doc_main_p">（4）Model：表示检测模式，0：默认人脸检测，1：快速人脸检测，2：大头照人脸检测（建议使用1快速人脸检测）</p>
        <p class="doc_main_p">（5）AttributesModel：是否需要属性信息（性别[0 不清楚 1 女性 2 男性]、年龄[<=0 表示不清楚]、是否戴眼镜[0 不戴眼镜 1 戴眼镜 2 太阳镜 <0 表示不清楚]）</p>
        <p class="doc_main_p">（6）FeatureModel：是否需要特征值</p>
        <p class="doc_main_p">（7）KeyPointModel：是否需要关键点信息（人脸形状72个关键点信息，先x后y【企业版提供】）</p>
        <p class="doc_main_p">（8）FaceDetectCallback(FaceStruct[] FaceStructs): 人脸检测结果回调FaceStructs检测结果结构体数组</p>
        <h3 class="doc_main_h3">返回值</h3>
		<detection-structural-array></detection-structural-array>
		<h3 class="doc_main_h3">示例代码</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">skFace.SKFaceImageDetect(bgrData,
        bitmap.getWidth(), bitmap.getHeight(), 1, true, true, true,
        new FaceDetectCallbackInterface() {
            @Override
            public void FaceDetectCallback (FaceStruct[] FaceStructs) {
                // TODO: 此处FaceStructs即是识别结果的返回值，请勿在方法内做任何耗时操作
            }
        });
FaceStruct[] FaceStructs = skFace.SKFaceImageDetect(bgrData,
        bitmap.getWidth(), bitmap.getHeight(), 1, true, true, true)</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import DetectionStructuralArray from '../../../../components/DetectionStructuralArray';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'detection-structural-array':DetectionStructuralArray,
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-Android','图片接口','图片人脸检测与分析'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfacesdkandroid/img/imgFaceDetection.vue